import * as SC from "./styles";

type InsightParagraphProps = {
    text: string;
};

export const InsightParagraph = ({ text }: InsightParagraphProps) => (
    <SC.InsightBodyParagraph>{text}</SC.InsightBodyParagraph>
);
